
  $('.for_scroll').on("click", function(){
    $('html,body').animate({
        scrollTop: $('form').last().filter(":visible").offset().top
    }, 700)
});
 